import React from "react";
import { renderRichText } from "gatsby-source-contentful/rich-text";
import { Options } from "~/molecules/BaseArticleBody";
import { colors } from "~/utils/colors";
import { breakPoints } from "~/utils/variables";
import "~/utils/styledJsx";

type Props = {
  description?: { raw?: string | null } | null;
};

export const DownloadArticleBody: React.FC<Props> = ({ description }) => {
  if (!description?.raw) {
    return null;
  }

  return (
    <>
      <style jsx>{`
        .mainContent {
          box-sizing: border-box;
          margin: 0;
          padding: 0 0 40px;
          width: 100%;
        }
        .mainContent :global(h2) {
          border-bottom: solid 2px ${colors.gray3};
          color: ${colors.defaultText};
          font-size: 20px;
          font-weight: 700;
          margin: 48px 0 20px;
          padding: 0 0 10px;
          scroll-margin-top: 140px;
        }
        .mainContent :global(h2:first-child) {
          margin-top: 0;
        }
        .mainContent :global(h3) {
          border-bottom: none;
          color: ${colors.defaultText};
          font-size: 18px;
          font-weight: 700;
          margin: 36px 0 12px;
          padding: 0 0 0 16px;
          position: relative;
          scroll-margin-top: 140px;
        }
        .mainContent :global(h3::before) {
          background-color: ${colors.orange};
          border-radius: 2px;
          bottom: 0;
          content: "";
          left: 0;
          position: absolute;
          top: 0;
          width: 4px;
        }
        .mainContent :global(h4) {
          color: ${colors.defaultText};
          font-size: 16px;
          font-weight: 700;
          margin: 28px 0 8px;
        }
        .mainContent :global(p) {
          color: ${colors.defaultText};
          font-size: 16px;
          font-weight: 400;
          line-height: 2;
          margin: 20px 0 0;
        }
        .mainContent :global(b),
        .mainContent :global(strong) {
          font-weight: 700;
        }
        .mainContent :global(p:empty) {
          margin: 0;
        }
        .mainContent :global(.embeddedImageWrapper) {
          margin: 24px 0 0;
          width: 100%;
        }
        .mainContent :global(.embeddedImageWrapper img) {
          border-radius: 12px;
          display: block;
          max-width: 100%;
        }
        .mainContent :global(.embeddedImageWrapper .description) {
          color: ${colors.littleBrightGray};
          font-size: 14px;
          margin-top: 8px;
        }
        .mainContent :global(ul) {
          font-size: 16px;
          font-weight: 400;
          line-height: 1.8;
          list-style: disc;
          margin: 24px 0 0;
          padding: 0 0 0 24px;
        }
        .mainContent :global(ul li),
        .mainContent :global(ol li) {
          margin-top: 10px;
        }
        .mainContent :global(ul li:first-child),
        .mainContent :global(ol li:first-child) {
          margin-top: 0;
        }
        .mainContent :global(ol) {
          font-size: 16px;
          font-weight: 400;
          line-height: 1.8;
          list-style: decimal;
          margin: 24px 0 0;
          padding: 0 0 0 24px;
        }
        .mainContent :global(ul li b),
        .mainContent :global(ul li strong),
        .mainContent :global(ol li b),
        .mainContent :global(ol li strong) {
          font-weight: 700;
        }
        .mainContent :global(hr) {
          border: none;
          border-top: 1px solid ${colors.gray4};
          height: 0;
          margin: 24px 0;
        }
        @media (${breakPoints.minPc}) {
          .mainContent :global(h2) {
            font-size: 26px;
          }
          .mainContent :global(h3) {
            font-size: 20px;
          }
        }
        @media (${breakPoints.sp}) {
          .mainContent {
            padding: 0 0 32px;
          }
          .mainContent :global(h2) {
            font-size: 20px;
            margin: 36px 0 16px;
          }
          .mainContent :global(h2:first-child) {
            margin-top: 0;
          }
          .mainContent :global(h3) {
            font-size: 17px;
            margin: 28px 0 10px;
          }
          .mainContent :global(h4) {
            font-size: 15px;
          }
          .mainContent :global(p) {
            font-size: 15px;
          }
          .mainContent :global(ul),
          .mainContent :global(ol) {
            font-size: 15px;
            padding: 0 0 0 20px;
          }
        }
      `}</style>
      <div className="mainContent">{renderRichText(description as any, Options)}</div>
    </>
  );
};
